import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PaginationPageEvent } from '@snapon/design-system-angular';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSort, Sort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { AppInfoService } from 'core/app-info/app-info.service';
import { LoadingState } from 'core/common-entities/loading-state.enum';
import { ActiveTab } from 'src/app/modules/shared/entities/active-tab.enum';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { ImportItemsQuoteService } from 'src/app/modules/shared/import-quotes-and-orders/import-items-quote.service';
import { StorageValues } from '../../../shared/entities/storage-values.enum';
import { QuoteListService } from '../../quotes/services/quote-list.service';
import { AdvancedSearchService } from '../../services/advanced-search.service';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
  standalone: false
})
export class OrderListComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() isOnAccountsPage: boolean;
  @Input() bpNumber: string;
  appStrings: AppLocalization = this.appInfoService.appStrings;
  dateFormat = this.appInfoService.dateFormat;
  templateValues = {
    quoteTypes: null,
    statusList: null
  };
  dataLoaded = {
    templateValues: false,
    orders: false,
    transactions: false,
    loaded: false
  };
  activeTab = ActiveTab;
  private subs = new Subscription();

  totalRecords = 0;
  currentPage = 0;
  pageSize = 15;
  pageOffset = 0;
  totalPages: number;
  orderList;
  isLoading = true;
  isPartialLoading = false;
  isLoaded;
  getListMethod;
  orderKey = StorageValues.OrderKey;

  displayedColumns: string[];
  isWithRadio = false;

  isAdmin = false;
  @ViewChild(MatSort) tableSort: MatSort;

  constructor(
    private appInfoService: AppInfoService,
    private quoteListService: QuoteListService,
    private cdRef: ChangeDetectorRef,
    private advancedSearchService: AdvancedSearchService,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private importItemsQuoteService: ImportItemsQuoteService
  ) { }

  ngOnInit() {
    this.displayedColumns = this.isOnAccountsPage ?
      [
        'contactName',
        'orderName',
        'orderNo',
        'orderDate',
        'type',
        'status',
        'total',
        'action'
      ] : [
        'accountManager',
        'accountName',
        'bpNumber',
        'contactName',
        'orderName',
        'orderNo',
        'orderDate',
        'type',
        'status',
        'total',
        'action'
      ];
    this.getListMethod = this.quoteListService.getOrdersList.bind(this.quoteListService);
    this.initData();
    this.isAdmin = this.appInfoService.isAdminTypeUser();
    this.subs.add(this.quoteListService.isProcessing$.subscribe(isLoading => {
      this.isLoading = isLoading === LoadingState.loading;
      this.isPartialLoading = isLoading === LoadingState.partiallyLoaded;
    }));
    this.subs.add(this.quoteListService.orderList$.subscribe(value => this.orderList = value));
    this.subs.add(this.quoteListService.totalOrderRecords$.subscribe(value => this.totalRecords = value));
    this.subs.add(this.quoteListService.totalOrderRecords$.subscribe(value => this.totalPages = Math.ceil(value / this.pageSize)));
    this.subs.add(this.quoteListService.currentPage$.subscribe(value => this.currentPage = value - 1));
    this.isWithRadio = !!this.importItemsQuoteService.getDestinationQuoteId();
  }

  ngAfterViewChecked() {
    if (this.dataLoaded.templateValues) {
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private initData() {
    this.quoteListService.getTemplateValues((templateValuesObject) => {
      this.templateValues = templateValuesObject;
      this.dataLoaded.templateValues = true;
    });
  }

  loadPage(event: PaginationPageEvent) {
    this.currentPage = event.pageNumber;
    this.quoteListService.updatePage(event.pageNumber, { forOrders: true });
    this.pageOffset = (event.pageNumber - 1) * this.pageSize;
  }

  sortData(sort: Sort) {
    if (!sort.active) {
      // reset sorting due to new search, no action needed
      return;
    } else if (!sort.direction) {
      // reset sorting due to clicking the sort arrow icon, reload default list
      sort = null;
      this.quoteListService.resetSortOnOrders();
    }

    this.resetPage();
    this.quoteListService.getOrdersList(null, sort);
  }

  resetSortIndicator(sort?: MatSort) {
    this.advancedSearchService.resetSort(this.tableSort, sort);
  }

  resetPage() {
    this.currentPage = 0;
  }

  navigateToOrder(orderId: string, bpNumber: number) {
    if (bpNumber) {
      this.router.navigate(['/quotes', orderId]);
    } else {
      this.router.navigate(['/quotes/lead', orderId]);
    }
  }

  onRadioChange(row: any) {
    this.importItemsQuoteService.setSelectedQuoteId(row.id);
  }
}
